import Vue from 'vue';
import Vuex from 'vuex';
import aiChat from './modules/aiChat.js';
Vue.use(Vuex);

const store = new Vuex.Store({
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	modules: {
		aiChat
	},
});

export default store;
